import { createRouter, createWebHistory } from 'vue-router';
import LoginPage from '../views/login/login-view.vue';
import HomePage from '../views/home/home-view.vue';
import VrEditView from '../views/vr/vr-edit-view.vue';
import LandingPage from '../views/landing/landing-view.vue';

const router = createRouter({
  history: createWebHistory(),
  routes: [
    {
      path: '/',
      name: 'Landing',
      component: LandingPage,
      meta: { public: true }
    },
    {
      path: '/login',
      name: 'Login',
      component: LoginPage,
      meta: { public: true }
    },
    {
      path: '/home',
      name: 'Home',
      component: HomePage,
      meta: { requiresAuth: true }
    },
    {
      path: '/vr/hall/:hallId',
      name: 'VrHallEdit',
      component: VrEditView,
      props: true,
      meta: { requiresAuth: true }
    }
  ]
});

// 添加全局前置守卫
router.beforeEach((to, from, next) => {
  const token = localStorage.getItem('token')
  
  // 已登录用户访问登录页时，直接进入管理后台
  if (to.path === '/login' && token) {
    next('/home')
    return
  }
  
  // 只拦截明确标记为需要登录的后台页面，公开首页无需登录
  if (to.meta.requiresAuth && !token) {
    next('/login')
    return
  }
  
  next()
})

export default router; 
